// Post messages to the embedding page (academy.measuremarketer.com) at every
// meaningful state in the booking funnel. The parent listens on 'message',
// filters by `source: 'mm-crm-form'`, and pushes onto window.dataLayer.
//
// Target origin is '*' because the iframe doesn't know which sites are
// embedding it. The parent must filter the incoming origin AND the source
// field to stay safe. See the Embed dialog in the admin for the parent
// snippet.

const SOURCE = 'mm-crm-form';

export function emit(type, payload = {}) {
  try {
    if (typeof window === 'undefined' || window.parent === window) return;
    window.parent.postMessage(
      { source: SOURCE, type, payload, ts: Date.now() },
      '*'
    );
  } catch (err) {
    // Swallow - never let an analytics emit break the form flow.
    if (typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn('mm-crm postMessage failed:', err?.message);
    }
  }
}
